/**
 * Ensure that Sentry is the first thing that's loaded initialized in order to instrument fetch() / xhr()
 * automatically
 */
import('./utils/sentry')
  .then((sentry) => sentry.initSentry())
  .finally(() => import('./App').then((app) => app.run()));

export default {};
